// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2c-0";
export var spinnerContainer = "_2c-1";